import { BottomSheetIllustrationContent } from "@clipboard-health/ui-components";
import { Button } from "@src/appV2/redesign/components/Button";
import { DialogFooter } from "@src/appV2/redesign/components/DialogFooter";

export interface AcceptNonInstantPayContentProps {
  onAccept: () => void;
  onCancel: () => void;
  isMissedPunchRequestEnabled: boolean;
}

export function AcceptNonInstantPayContent(props: AcceptNonInstantPayContentProps) {
  const { onAccept, onCancel, isMissedPunchRequestEnabled } = props;

  const title = isMissedPunchRequestEnabled
    ? "Submit Missed Punch Request Later"
    : "Submit Paper Timesheet Later";

  const description = isMissedPunchRequestEnabled
    ? "By proceeding, this shift will no longer be eligible for InstantPay. You'll need to submit a missed punch request for workplace approval. Most requests are approved within 3 business days."
    : "By proceeding, this shift will no longer be eligible for InstantPay. You'll need to submit a paper timesheet, and payment may take up to two business days to process.";

  return (
    <>
      <BottomSheetIllustrationContent
        illustrationType="non-instant-pay"
        title={title}
        description={description}
      />
      <DialogFooter
        orientation="vertical"
        sx={{ marginTop: 10 }}
        closeButtonAriaLabel="Cancel"
        closeButtonIconType="arrow-left"
        onClose={() => {
          onCancel();
        }}
      >
        <Button
          fullWidth
          variant="destructive"
          size="large"
          onClick={() => {
            onAccept();
          }}
        >
          Accept non-instant pay
        </Button>
      </DialogFooter>
    </>
  );
}
